/**
 * IconTile — a rounded square that frames a single lucide icon.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type IconTileTone = 'neutral' | 'dark' | 'green';
export type IconTileSize = 38 | 42 | 44;

export interface IconTileProps {
  tone?: IconTileTone;
  size?: IconTileSize;
  children: ReactNode;
  className?: string;
}

const TONES: Record<IconTileTone, string> = {
  neutral: 'bg-muted text-foreground',
  dark: 'bg-primary text-white',
  green: 'border border-success-border bg-success-bg text-success',
};

const SIZES: Record<IconTileSize, string> = {
  38: 'h-[38px] w-[38px]',
  42: 'h-[42px] w-[42px]',
  44: 'h-[44px] w-[44px]',
};

export function IconTile({ tone = 'neutral', size = 44, children, className }: IconTileProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-[11px]',
        TONES[tone],
        SIZES[size],
        className,
      )}
    >
      {children}
    </span>
  );
}
